import React, { useState } from 'react';
import { formatCurrency } from '../../../../utils/helpers';

import dayjs from 'dayjs';
import { useEstudianteContext } from '../EstudianteContext';
import CamposPago from '../../Components/CamposPago';

const PagoForm = () => {
    const {estudiante, gradosRanking, setPagoInfo, pagoInfo, servicios, montoPagar, page, servicio, pagoEvaluacion, isInscripcion} = useEstudianteContext();

    const grupo = estudiante.curso?.grupoPago;
    const grado = estudiante.curso?.grado;
    const resta = montoPagar - pagoInfo.pago - parseFloat(pagoEvaluacion);
    const totalPagar = parseFloat(montoPagar) - parseFloat(pagoEvaluacion);

    return (
        <div
            className={`body-transferencia page-${page}`}
        >
            <input
                type="hidden"
                name="pago_info[abono_total]"
                value={totalPagar}
            />
            <input
                type="hidden"
                name="pago_info[monto]"
                value={montoPagar}
            />
            <input
                type="hidden"
                name="pago_info[descuento]"
                value={pagoEvaluacion}
            />
            <input
                type="hidden"
                name="pago_info[balance_total]"
                value={resta < 0 ? 0 : resta}
            />
            <input
                type="hidden"
                name="pago_info[servicio_nombre]"
                value={servicio.nombre}
            />
            <input
                type="hidden"
                name="pago_info[servicio_id]"
                value={servicio.id}
            />
            <div className="transferencia-page py-0">
                <h3
                    className="confirmacion-monto"
                    style={{ marginBottom: "5px" }}
                >
                    {estudiante.nombre} {estudiante.primerApellido} {estudiante.segundoApellido}
                </h3>
                {isInscripcion && (
                    <div className="row p-b-1 transaccion-detalles-cuenta">
                        <div className="col-6">Inscripción:</div>
                        <div className="col-6 text-right">
                            <strong>
                                {formatCurrency(
                                    montoPagar
                                )}
                            </strong>
                        </div>
                    </div>
                )}
                {parseFloat(pagoEvaluacion) > 0 && (
                    <div className="row p-b-1 transaccion-detalles-cuenta">
                        <div className="col-6">Evaluación:</div>
                        <div className="col-6 text-right">
                            <strong>
                                -{formatCurrency(
                                    pagoEvaluacion
                                )}
                            </strong>
                        </div>
                    </div>
                )}
                <div className="row p-b-1 transaccion-detalles-cuenta">
                    <div className="col-6">Total a pagar:</div>
                    <div className="col-6 text-right">
                        <strong>
                            {formatCurrency(
                                totalPagar
                            )}
                        </strong>
                    </div>
                </div>

                <CamposPago
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}
                    total={totalPagar}
                />
                <div className="form-group d-none">
                    <label>Comentario</label>
                    <textarea
                        className="form-control"
                        name="pago_info[notas]"
                    ></textarea>
                </div>
            </div>
            <div className="transferencia-page py-0">
                <h3
                    className={`text-center confirmacion-monto ${
                        page === 1 ? "d-none" : "d-block"
                    }`}
                    style={{ marginBottom: "5px" }}
                >
                    {estudiante.nombre} {estudiante.primerApellido} {estudiante.segundoApellido}
                </h3>
                <h3
                    className={`text-center ${
                        page === 1 ? "d-none" : "d-block"
                    }`}
                >
                    Confirmación de transacción
                </h3>
                <h4
                    className={`text-center confirmacion-monto ${
                        page === 1 ? "d-none" : "d-block"
                    }`}
                >
                    Total: {formatCurrency(totalPagar)}
                </h4>
                <div className="row">
                    <div className="col-md-6">
                        <small>Método de pago:</small><br/> <strong className='uppercase'>{pagoInfo.tipo_pago}</strong><br/>
                        <small>Grado:</small><br/> <strong>{estudiante?.curso?.grado?.nombre}</strong><br/>
                        {estudiante?.curso?.salidaOptativa?.nombre && (<>
                            <small>Optativa:</small><br/> <strong>{estudiante?.curso?.salidaOptativa?.nombre}</strong><br/>
                        </>)}
                        <small>Grupo de Pago:</small><br/> <strong className='uppercase'>{grupo}</strong><br/>
                    </div>
                    <div className="col-md-6">
                        <small>Año Escolar:</small><br/> <strong>{estudiante?.curso?.periodoAcademico?.nombre}</strong><br/>
                        <small>Sección:</small><br/> <strong>{estudiante?.curso?.seccion?.nombre}</strong><br/>
                        {estudiante?.beca?.nombre && (<>
                            <small>Beca:</small><br/> <strong>{estudiante?.beca?.nombre}</strong><br/>
                        </>)}
                    </div>
                </div>
                {grado && grupo && (
                    <div className="m-t-15">
                        <table className="table table-small">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Monto</th>
                                    <th className="text-center">Cuotas</th>
                                    <th className="text-right">Primer Pago</th>
                                </tr>
                            </thead>
                            <tbody>
                                {grupo && grado && servicios.filter(s => s.nombre.includes('ensualidad')).map(servicio => (
                                    <ServicioRow
                                        key={servicio.id}
                                        grado={grado}
                                        grupo={grupo}
                                        servicio={servicio}
                                        gradosRanking={gradosRanking}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PagoForm;

const ServicioRow = ({grupo, grado, servicio, gradosRanking}) => {
    const rank = gradosRanking[grado?.nombre];

    const precio = servicio.configuracion[grupo]?.filter(c => {
        return gradosRanking[c.grado_desde] <= rank && gradosRanking[c.grado_hasta] >= rank;
    }).shift();

    return (
        <tr key={servicio.id}>
            <td>
                <label>
                    <span>{servicio.nombre}</span>
                </label>
            </td>
            <td>
                {formatCurrency(precio?.monto)}
            </td>
            <td className="text-center">
                {servicio.cuotas}
            </td>
            <td className="text-right">{dayjs(servicio.fechaInicio).format('MMM DD')}</td>
        </tr>
    );
}
